import { render, staticRenderFns } from "./afterSaleManageInfo.vue?vue&type=template&id=68c2a956&scoped=true"
import script from "./afterSaleManageInfo.vue?vue&type=script&lang=js"
export * from "./afterSaleManageInfo.vue?vue&type=script&lang=js"
import style0 from "./afterSaleManageInfo.vue?vue&type=style&index=0&id=68c2a956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c2a956",
  null
  
)

export default component.exports